export const CHECKBOX_STATUSES = {
  UNCHECKED: 'UNCHECKED',
  CHECKED: 'CHECKED',
  INDETERMINATE: 'INDETERMINATE',
  INACTIVE: 'INACTIVE',
} as const
